/**
 * Chart rows from a `{ rawEnumValue: count }` breakdown. `label` turns the raw
 * backend value (`past_due`, `country_club`) into the translated name shown on
 * the axis / legend — QA R2-09 found the raw keys rendered as-is.
 */
export function toChartData(
  breakdown: Record<string, number> | undefined,
  label: (raw: string) => string = (raw) => raw,
): { name: string; value: number }[] {
  return Object.entries(breakdown ?? {}).map(([raw, value]) => ({ name: label(raw), value }));
}
